<template>
  <v-row>
    <v-col cols="12" sm="6" md="4" class="date ml-2 d-flex align-center">
      <span class="mr-1">{{ $tc("date.from") }}</span>
      <v-icon @click="changeDateBy('dateFrom', 'yesterday')" class="mr-1">
        fa-angle-left
      </v-icon>
      <v-text-field
        v-model="formattedDateFrom"
        hide-details
        class="inputDate"
        placeholder="dd/mm/yyyy"
        dense
        flat
        solo
        maxlength="10"
        v-mask="'##/##/####'"
        @blur="onManualDateFromChange"
      />
      <v-menu
        ref="menuFrom"
        v-model="menuFrom"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mr-1" small v-bind="attrs" v-on="on">
            far fa-calendar
          </v-icon>
        </template>
        <v-date-picker
          v-model="dateFrom"
          @input="onDateFromChange"
          @change="menuFrom = false"
          locale="es"
        />
      </v-menu>
      <v-icon @click="changeDateBy('dateFrom', 'laterday')" class="ml-1">
        fa-angle-right
      </v-icon>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="date ml-2 d-flex align-center">
      <span class="mr-1">{{ $tc("date.to") }}</span>
      <v-icon @click="changeDateBy('dateTo', 'yesterday')" class="mr-1">
        fa-angle-left
      </v-icon>
      <v-text-field
        v-model="formattedDateTo"
        hide-details
        class="inputDate"
        placeholder="dd/mm/yyyy"
        dense
        flat
        solo
        maxlength="10"
        v-mask="'##/##/####'"
        @blur="onManualDateToChange"
      />
      <v-menu
        ref="menuTo"
        v-model="menuTo"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mr-1" small v-bind="attrs" v-on="on">
            far fa-calendar
          </v-icon>
        </template>
        <v-date-picker
          v-model="dateTo"
          @input="onDateToChange"
          @change="menuTo = false"
          locale="es"
        />
      </v-menu>
      <v-icon @click="changeDateBy('dateTo', 'laterday')" class="ml-1">
        fa-angle-right
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      menuTo: false,
      dateTo: new Date().toISOString().substr(0, 10),
      menuFrom: false,
      dateFrom: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    formattedDateFrom: {
      get() {
        const [year, month, day] = this.dateFrom.split("-");
        return `${day}/${month}/${year}`;
      },
      set(value) {
        const [day, month, year] = value.split("/");
        const parsed = `${year}-${month}-${day}`;
        if (moment(parsed, "YYYY-MM-DD", true).isValid()) {
          this.dateFrom = parsed;
        }
      },
    },
    formattedDateTo: {
      get() {
        const [year, month, day] = this.dateTo.split("-");
        return `${day}/${month}/${year}`;
      },
      set(value) {
        const [day, month, year] = value.split("/");
        const parsed = `${year}-${month}-${day}`;
        if (moment(parsed, "YYYY-MM-DD", true).isValid()) {
          this.dateTo = parsed;
        }
      },
    },
  },
  methods: {
    onDateFromChange(date) {
      if (!moment(date, "YYYY-MM-DD", true).isValid()) return;

      if (moment(date).isAfter(this.dateTo)) {
        this.dateTo = date;
        this.setDateTo(date);
      }
      this.dateFrom = date;
      this.setDate(date);
    },
    onManualDateFromChange() {
      const [d, m, y] = this.formattedDateFrom.split("/");
      const parsed = `${y}-${m}-${d}`;
      if (moment(parsed, "YYYY-MM-DD", true).isValid()) {
        this.onDateFromChange(parsed);
      } else {
        const [year, month, day] = this.dateFrom.split("-");
        this.formattedDateFrom = `${day}/${month}/${year}`;
      }
    },
    onDateToChange(date) {
      if (!moment(date, "YYYY-MM-DD", true).isValid()) return;

      if (moment(date).isBefore(this.dateFrom)) {
        this.dateFrom = date;
        this.setDate(date);
      }
      this.dateTo = date;
      this.setDateTo(date);
    },
    onManualDateToChange() {
      const [d, m, y] = this.formattedDateTo.split("/");
      const parsed = `${y}-${m}-${d}`;
      if (moment(parsed, "YYYY-MM-DD", true).isValid()) {
        this.onDateToChange(parsed);
      } else {
        const [year, month, day] = this.dateTo.split("-");
        this.formattedDateTo = `${day}/${month}/${year}`;
      }
    },
    changeDateBy(model, action) {
      const actual = this[model];
      let newDate = moment(actual);
      newDate =
        action === "yesterday"
          ? newDate.subtract(1, "days")
          : newDate.add(1, "days");
      const formatted = newDate.format("YYYY-MM-DD");
      model === "dateFrom"
        ? this.onDateFromChange(formatted)
        : this.onDateToChange(formatted);
    },
    setDate(date) {
      localStorage.setItem("fechaFiltroDesde", date);
      this.$store.commit("gestionTiempos/setDate", date);
    },
    setDateTo(date) {
      localStorage.setItem("fechaFiltroHasta", date);
      this.$store.commit("gestionTiempos/setDateTo", date);
    },
  },
  mounted() {
    const savedDateFrom = localStorage.getItem("fechaFiltroDesde");
    const savedDateTo = localStorage.getItem("fechaFiltroHasta");

    if (savedDateFrom && moment(savedDateFrom, "YYYY-MM-DD", true).isValid()) {
      this.dateFrom = savedDateFrom;
    }

    if (savedDateTo && moment(savedDateTo, "YYYY-MM-DD", true).isValid()) {
      this.dateTo = savedDateTo;
    }
  }
};
</script>
<style scoped>
.inputDate {
  font-size: 16px !important;
  width: 112px;
}
.date {
  max-width: 250px !important;
  display: flex;
  align-items: center !important;
  max-height: 40px !important;
  border: 1px solid #ccc;
  border-radius: 5px !important;
  background-color: white;
}
</style>
